const isEmpty = (
  element: string | ReadonlyArray<unknown> | null | undefined,
): boolean => element == null || element.length === 0;

export default isEmpty;
